var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 heading" },
            [_vm._v("Product Classification")]
          ),
          _c(
            "div",
            { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
            [
              _vm.prodClassCriteria.current_slide_number == 0
                ? _c("p", { staticClass: "sub_caption" }, [
                    _vm._v(
                      " Medical devices are classified according to the level of harm they may pose to users or patients. Based on your inputs our step-by-step guide suggests the medical device classification for multiple markets. Select from the Country list below to get started! We’ve also added a Classification Rationale report for Europe’s MDR regulations. The report leverages your inputs to the EU MDR classification questionnaire plus an optional review by an Emergo consultant to produce a rationale report that can be used in your Technical File or for strategic planning. This is our beta release so stay tuned for enhancements as we add markets and further refine the tool. "
                    ),
                  ])
                : _vm._e(),
              _vm.prodClassCriteria.current_slide_number != 0
                ? _c("p", { staticClass: "sub_caption" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.cases[_vm.prodClassCriteria.current_slide_number]
                            .caption
                        ) +
                        " "
                    ),
                    _c("span", { staticClass: "sub_caption_bold" }, [
                      _vm._v(
                        _vm._s(
                          _vm.cases[_vm.prodClassCriteria.current_slide_number]
                            .sub_caption
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "ul",
              { staticClass: "crumb-trail" },
              _vm._l(_vm.cases, function (case_item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "col-md-3 col-sm-3 col-lg-3 p-0",
                    class: {
                      "is-active-slide col-xs-6":
                        _vm.prodClassCriteria.current_slide_number === index,
                      "col-xs-2":
                        _vm.prodClassCriteria.current_slide_number !== index,
                      completed_slide:
                        _vm.prodClassCriteria.current_slide_number > index,
                    },
                  },
                  [
                    _c("div", { staticClass: "crumb" }, [
                      _c("img", {
                        staticClass: "breadcrumb-img",
                        attrs: {
                          src: "/static/images/icons/circle_check.svg",
                          alt: "circle-icon",
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(case_item.title))]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
            [
              _c("div", { staticClass: "tab-content" }, [
                _c(
                  "div",
                  {
                    class: {
                      "tab-pane fade in active":
                        _vm.prodClassCriteria.current_slide_number === 0,
                      "tab-pane fade in ":
                        _vm.prodClassCriteria.current_slide_number != 0,
                    },
                    attrs: { id: "createNewAlert1" },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "notification_box" }, [
                        _vm._m(0),
                        _c("div", { staticClass: "row padding_rl20" }, [
                          _vm._m(1),
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-8 col-md-8 margin_bottom_15",
                            },
                            [
                              _c("div", { staticClass: "class-radio" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-5 col-lg-4 pl-0",
                                  },
                                  [
                                    _c(
                                      "base-radio",
                                      {
                                        staticClass:
                                          "class-radio__input general padding_rt10_lft0",
                                        attrs: {
                                          name: _vm.devTypMD,
                                          optionValue: "GeneralMedicalDevice",
                                          label: "GeneralMedicalDevice",
                                        },
                                        on: {
                                          click: _vm.filterCountries,
                                          change: _vm.filterCountries,
                                        },
                                        model: {
                                          value: _vm.medical_device_type,
                                          callback: function ($$v) {
                                            _vm.medical_device_type = $$v
                                          },
                                          expression: "medical_device_type",
                                        },
                                      },
                                      [_vm._v(" General Medical Device ")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-7 col-lg-8 pl-0",
                                  },
                                  [
                                    _c(
                                      "base-radio",
                                      {
                                        staticClass:
                                          "class-radio__input general padding_rt10_lft0",
                                        attrs: {
                                          name: _vm.devTypIVD,
                                          optionValue: "IVDMedicalDevice",
                                          label: "IVDMedicalDevice",
                                        },
                                        on: {
                                          click: _vm.filterCountries,
                                          change: _vm.filterCountries,
                                        },
                                        model: {
                                          value: _vm.medical_device_type,
                                          callback: function ($$v) {
                                            _vm.medical_device_type = $$v
                                          },
                                          expression: "medical_device_type",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "In Vitro Diagnostic (IVD) Medical Device"
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "row padding_rl20" }, [
                          _vm._m(2),
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-4 col-md-4 margin_bottom_15",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "search-input" },
                                [
                                  _vm.prodClassCriteria.filteredCountries.length
                                    ? _c(
                                        "multiselect",
                                        {
                                          staticClass:
                                            "multiselect-single-dropdown",
                                          attrs: {
                                            showLabels: false,
                                            "close-on-select": true,
                                            "allow-empty": false,
                                            searchable: true,
                                            options:
                                              _vm.prodClassCriteria.filteredCountries.map(
                                                (country) =>
                                                  country.country_value
                                              ),
                                            "custom-label":
                                              _vm.getCountryNameById,
                                            placeholder: "Select Country",
                                          },
                                          on: {
                                            input: _vm.showCriteriaForCountry,
                                          },
                                          model: {
                                            value:
                                              _vm.prodClassCriteria.country,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.prodClassCriteria,
                                                "country",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "prodClassCriteria.country",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "noResult" },
                                              slot: "noResult",
                                            },
                                            [_vm._v("No matching data")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "row padding_rl20" }, [
                          _vm._m(3),
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-4 col-md-4 margin_bottom_15",
                            },
                            [
                              _c("div", { staticClass: "search-input" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.prodClassCriteria.device_name,
                                      expression:
                                        "prodClassCriteria.device_name",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  class: _vm.form_validation_messages[
                                    "device_name"
                                  ]["displayError"]
                                    ? "invalid-border"
                                    : "",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Device Name",
                                  },
                                  domProps: {
                                    value: _vm.prodClassCriteria.device_name,
                                  },
                                  on: {
                                    change: _vm.resetErrorMsg,
                                    focus: _vm.resetErrorMsg,
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.prodClassCriteria,
                                        "device_name",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm.form_validation_messages["device_name"][
                                  "displayError"
                                ]
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "custom-error-class pt-8",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.form_validation_messages[
                                                "device_name"
                                              ]["errorMessage"]
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    class: {
                      "tab-pane fade in active":
                        _vm.prodClassCriteria.current_slide_number === 1,
                      "tab-pane fade in ":
                        _vm.prodClassCriteria.current_slide_number != 1,
                    },
                    attrs: { id: "createNewAlert2" },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "notification_box" },
                        _vm._l(
                          _vm.prodClassCriteria.compositeArrayWrapper.dataArray,
                          function (classData, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "padding_rl20" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "padding_rt10_lft0 p-b10" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "class_question" },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              classData.vital_characteristic
                                            ),
                                          },
                                        }),
                                        classData.children &&
                                        classData.children[1] &&
                                        classData.children[1]
                                          .characteristic_type == "NumberEntry"
                                          ? _c("div", [_vm._v(" New ")])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "padding_rt10_lft0 p-b10" },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          classData.explanatory_text
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._l(
                                  classData.children,
                                  function (option, index) {
                                    return _c("div", { key: index }, [
                                      option.characteristic_type !==
                                        "NumberEntry" &&
                                      classData.multi_select == "Y"
                                        ? _c(
                                            "div",
                                            { staticClass: "mt-3 mb-5" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "checkbox mr-12",
                                                },
                                                [
                                                  _c("label", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .prodClassCriteria
                                                              .selectedChoices,
                                                          expression:
                                                            "prodClassCriteria.selectedChoices",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "tools_check vital-char-style m-r-14",
                                                      attrs: {
                                                        type: "checkbox",
                                                        id:
                                                          option.vital_characteristic +
                                                          "_" +
                                                          option.characteristic_type +
                                                          "_" +
                                                          option.level,
                                                        disabled:
                                                          _vm.disabledChoices.includes(
                                                            option.level
                                                          ),
                                                      },
                                                      domProps: {
                                                        value:
                                                          option.vital_characteristic +
                                                          "|" +
                                                          option.characteristic_type +
                                                          "|" +
                                                          option.level +
                                                          "|" +
                                                          option.classification_code +
                                                          "|" +
                                                          option.classification_notes +
                                                          "|" +
                                                          option.intrim_class +
                                                          "|" +
                                                          option.rule_ref +
                                                          "|" +
                                                          classData.vital_characteristic +
                                                          "|" +
                                                          option.intrim_class +
                                                          "|" +
                                                          option.class_override +
                                                          "|" +
                                                          option.highest_class_override,
                                                        checked: Array.isArray(
                                                          _vm.prodClassCriteria
                                                            .selectedChoices
                                                        )
                                                          ? _vm._i(
                                                              _vm
                                                                .prodClassCriteria
                                                                .selectedChoices,
                                                              option.vital_characteristic +
                                                                "|" +
                                                                option.characteristic_type +
                                                                "|" +
                                                                option.level +
                                                                "|" +
                                                                option.classification_code +
                                                                "|" +
                                                                option.classification_notes +
                                                                "|" +
                                                                option.intrim_class +
                                                                "|" +
                                                                option.rule_ref +
                                                                "|" +
                                                                classData.vital_characteristic +
                                                                "|" +
                                                                option.intrim_class +
                                                                "|" +
                                                                option.class_override +
                                                                "|" +
                                                                option.highest_class_override
                                                            ) > -1
                                                          : _vm
                                                              .prodClassCriteria
                                                              .selectedChoices,
                                                      },
                                                      on: {
                                                        change: [
                                                          function ($event) {
                                                            var $$a =
                                                                _vm
                                                                  .prodClassCriteria
                                                                  .selectedChoices,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v =
                                                                  option.vital_characteristic +
                                                                  "|" +
                                                                  option.characteristic_type +
                                                                  "|" +
                                                                  option.level +
                                                                  "|" +
                                                                  option.classification_code +
                                                                  "|" +
                                                                  option.classification_notes +
                                                                  "|" +
                                                                  option.intrim_class +
                                                                  "|" +
                                                                  option.rule_ref +
                                                                  "|" +
                                                                  classData.vital_characteristic +
                                                                  "|" +
                                                                  option.intrim_class +
                                                                  "|" +
                                                                  option.class_override +
                                                                  "|" +
                                                                  option.highest_class_override,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  _vm.$set(
                                                                    _vm.prodClassCriteria,
                                                                    "selectedChoices",
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ])
                                                                  )
                                                              } else {
                                                                $$i > -1 &&
                                                                  _vm.$set(
                                                                    _vm.prodClassCriteria,
                                                                    "selectedChoices",
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      )
                                                                  )
                                                              }
                                                            } else {
                                                              _vm.$set(
                                                                _vm.prodClassCriteria,
                                                                "selectedChoices",
                                                                $$c
                                                              )
                                                            }
                                                          },
                                                          function ($event) {
                                                            return _vm.choicesChanged(
                                                              option.vital_characteristic +
                                                                "|" +
                                                                option.characteristic_type +
                                                                "|" +
                                                                option.level +
                                                                "|" +
                                                                option.classification_code +
                                                                "|" +
                                                                option.classification_notes +
                                                                "|" +
                                                                option.intrim_class +
                                                                "|" +
                                                                option.rule_ref +
                                                                "|" +
                                                                classData.vital_characteristic +
                                                                "|" +
                                                                option.intrim_class +
                                                                "|" +
                                                                option.class_override +
                                                                "|" +
                                                                option.highest_class_override
                                                            )
                                                          },
                                                        ],
                                                      },
                                                    }),
                                                    _c("span", {
                                                      staticClass: "cr",
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "vital-char-style",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      option.vital_characteristic
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : option.characteristic_type ===
                                          "Response"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "search-input" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.prodClassCriteria
                                                          .componentName[
                                                          _vm.ivdrCurrCtr
                                                        ],
                                                      expression:
                                                        "prodClassCriteria.componentName[ivdrCurrCtr]",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-control tf-width-20",
                                                  class:
                                                    _vm
                                                      .form_validation_messages[
                                                      "ivdr_component_name"
                                                    ]["displayError"] ||
                                                    _vm
                                                      .form_validation_messages[
                                                      "ivdr_duplicate_component"
                                                    ]["displayError"]
                                                      ? "invalid-border"
                                                      : "",
                                                  attrs: {
                                                    type: "text",
                                                    id:
                                                      option.vital_characteristic +
                                                      "_" +
                                                      option.characteristic_type +
                                                      "_" +
                                                      option.level,
                                                    disabled:
                                                      _vm.disabledChoices.includes(
                                                        option.level
                                                      ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.prodClassCriteria
                                                        .componentName[
                                                        _vm.ivdrCurrCtr
                                                      ],
                                                  },
                                                  on: {
                                                    keydown: function ($event) {
                                                      return _vm.responseChanged(
                                                        option.vital_characteristic +
                                                          "|" +
                                                          option.characteristic_type +
                                                          "|" +
                                                          option.level +
                                                          "|" +
                                                          option.classification_code +
                                                          "|" +
                                                          option.classification_notes +
                                                          "|" +
                                                          option.intrim_class +
                                                          "|" +
                                                          option.rule_ref +
                                                          "|" +
                                                          classData.vital_characteristic +
                                                          "|" +
                                                          option.intrim_class +
                                                          "|" +
                                                          option.class_override +
                                                          "|" +
                                                          option.highest_class_override
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.prodClassCriteria
                                                          .componentName,
                                                        _vm.ivdrCurrCtr,
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm.form_validation_messages[
                                                  "ivdr_component_name"
                                                ]["displayError"]
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "custom-error-class pt-8",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .form_validation_messages[
                                                                "ivdr_component_name"
                                                              ]["errorMessage"]
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.form_validation_messages[
                                                  "ivdr_duplicate_component"
                                                ]["displayError"]
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "custom-error-class pt-8",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .form_validation_messages[
                                                                "ivdr_duplicate_component"
                                                              ]["errorMessage"]
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-checkbox__label",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "vital-char-style",
                                                    attrs: {
                                                      for:
                                                        option.vital_characteristic +
                                                        "_" +
                                                        option.characteristic_type +
                                                        "_" +
                                                        option.level,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "class_answer question_details",
                                                      },
                                                      [
                                                        _vm.info == true
                                                          ? _c(
                                                              "base-tooltip",
                                                              {
                                                                attrs: {
                                                                  content:
                                                                    option.level,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "email_tooltip",
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fa fa-question-circle",
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "class-radio m-t-3",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {},
                                                  [
                                                    _c(
                                                      "base-radio",
                                                      {
                                                        staticClass:
                                                          "class-radio__input",
                                                        attrs: {
                                                          id:
                                                            option.vital_characteristic +
                                                            "_" +
                                                            option.characteristic_type +
                                                            "_" +
                                                            option.level,
                                                          name:
                                                            option.id +
                                                            "-" +
                                                            option.level,
                                                          optionValue:
                                                            option.vital_characteristic +
                                                            "|" +
                                                            option.characteristic_type +
                                                            "|" +
                                                            option.level +
                                                            "|" +
                                                            option.classification_code +
                                                            "|" +
                                                            option.classification_notes +
                                                            "|" +
                                                            option.intrim_class +
                                                            "|" +
                                                            option.rule_ref +
                                                            "|" +
                                                            classData.vital_characteristic +
                                                            "|" +
                                                            option.intrim_class +
                                                            "|" +
                                                            option.class_override +
                                                            "|" +
                                                            option.highest_class_override,
                                                          label:
                                                            option.vital_characteristic +
                                                            "|" +
                                                            option.characteristic_type +
                                                            "|" +
                                                            option.level +
                                                            "|" +
                                                            option.classification_code +
                                                            "|" +
                                                            option.classification_notes +
                                                            "|" +
                                                            option.intrim_class +
                                                            "|" +
                                                            option.rule_ref +
                                                            "|" +
                                                            classData.vital_characteristic +
                                                            "|" +
                                                            option.intrim_class +
                                                            "|" +
                                                            option.class_override +
                                                            "|" +
                                                            option.highest_class_override,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.optionPicked,
                                                          change:
                                                            _vm.optionPicked,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .prodClassCriteria
                                                              .selectedOptions,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.prodClassCriteria,
                                                              "selectedOptions",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "prodClassCriteria.selectedOptions",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "vital-char-style",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                option.vital_characteristic
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                      _c("div", { staticClass: "row" }, [
                                        option.explanatory_text
                                          ? _c(
                                              "div",
                                              { staticClass: "pl-30 p-b10" },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "padding_rt10_lft4 cust-margin",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      option.explanatory_text
                                                    ),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.ivdrKitFlow &&
                                        option.vital_characteristic === "Yes" &&
                                        option.level === "10-1" &&
                                        _vm.prodClassCriteria.country ===
                                          "EU IVDR"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-3 search-input",
                                              },
                                              [
                                                _c("span", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.ivdrTotalComponents,
                                                        expression:
                                                          "ivdrTotalComponents",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control tf-width-20",
                                                    class:
                                                      _vm
                                                        .form_validation_messages[
                                                        "ivdr_total_components"
                                                      ]["displayError"] ||
                                                      _vm
                                                        .form_validation_messages[
                                                        "ivdr_invalid_components"
                                                      ]["displayError"]
                                                        ? "invalid-border"
                                                        : "",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "Number of kit components",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.ivdrTotalComponents,
                                                    },
                                                    on: {
                                                      change: _vm.resetErrorMsg,
                                                      focus: _vm.resetErrorMsg,
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.ivdrTotalComponents =
                                                          $event.target.value
                                                      },
                                                    },
                                                  }),
                                                  _vm.form_validation_messages[
                                                    "ivdr_total_components"
                                                  ]["displayError"]
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "custom-error-class pt-8",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .form_validation_messages[
                                                                  "ivdr_total_components"
                                                                ][
                                                                  "errorMessage"
                                                                ]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.form_validation_messages[
                                                    "ivdr_invalid_components"
                                                  ]["displayError"]
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "custom-error-class pt-8",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .form_validation_messages[
                                                                  "ivdr_invalid_components"
                                                                ][
                                                                  "errorMessage"
                                                                ]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ])
                                  }
                                ),
                              ],
                              2
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    class: {
                      "tab-pane fade in active":
                        _vm.prodClassCriteria.current_slide_number === 2,
                      "tab-pane fade in ":
                        _vm.prodClassCriteria.current_slide_number != 2,
                    },
                    attrs: { id: "createNewAlert3" },
                  },
                  [
                    !_vm.ivdrKitFlow
                      ? _c(
                          "div",
                          [
                            _c("classification-summary", {
                              attrs: {
                                info: _vm.info,
                                debug: _vm.debug,
                                ivdrCurrCtr: _vm.ivdrCurrCtr,
                                prodClassCriteria: _vm.prodClassCriteria,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.ivdrKitFlow
                      ? _c(
                          "div",
                          [
                            _c("classification-summary-kit", {
                              attrs: {
                                info: _vm.info,
                                debug: _vm.debug,
                                ivdrCurrCtr: _vm.ivdrCurrCtr,
                                ivdrTotalComponents: _vm.ivdrTotalComponents,
                                prodClassCriteria: _vm.prodClassCriteria,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm.prodClassCriteria.country === "EU IVDR"
                  ? _c("div", {
                      class: {
                        "tab-pane fade in active":
                          _vm.prodClassCriteria.current_slide_number === 2,
                        "tab-pane fade in ":
                          _vm.prodClassCriteria.current_slide_number != 2,
                      },
                      attrs: { id: "createNewAlert3" },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    class: {
                      "tab-pane fade in active":
                        _vm.prodClassCriteria.current_slide_number === 3,
                      "tab-pane fade in ":
                        _vm.prodClassCriteria.current_slide_number != 3,
                    },
                    attrs: { id: "createNewAlert4" },
                  },
                  [
                    !_vm.ivdrKitFlow
                      ? _c("classification-result-page", {
                          attrs: {
                            info: _vm.info,
                            account_id: _vm.account_id,
                            roleId: _vm.roleId,
                            userId: _vm.userId,
                            debug: _vm.debug,
                            ivdrCurrCtr: _vm.ivdrCurrCtr,
                            pageConfig: _vm.pageConfig,
                            ivdrKitFlow: _vm.ivdrKitFlow,
                            kitClassSummary: _vm.kitClassSummary,
                            prodClassCriteria: _vm.prodClassCriteria,
                          },
                        })
                      : _vm._e(),
                    _vm.ivdrKitFlow
                      ? _c("classification-result-page-kit", {
                          attrs: {
                            info: _vm.info,
                            account_id: _vm.account_id,
                            roleId: _vm.roleId,
                            userId: _vm.userId,
                            debug: _vm.debug,
                            ivdrCurrCtr: _vm.ivdrCurrCtr,
                            pageConfig: _vm.pageConfig,
                            ivdrKitFlow: _vm.ivdrKitFlow,
                            kitClassSummary: _vm.kitClassSummary,
                            prodClassCriteria: _vm.prodClassCriteria,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "row" }, [
          _vm.validationMsg && _vm.prodClassCriteria.current_slide_number > 0
            ? _c(
                "div",
                { staticClass: "col-lg-12 col-md-12 col-ms-12 col-xs-12" },
                [
                  _c("div", { staticClass: "alert alert-danger error-msg" }, [
                    _vm._v(_vm._s(_vm.validationMsg)),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "row case-slider__navigation margin_top_bottom_15" },
          [
            _vm.prodClassCriteria.current_slide_number != 0 &&
            this.prodClassCriteria.classificationFinalized == false
              ? _c(
                  "div",
                  { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button m-t5",
                        on: { click: _vm.backWrapper },
                      },
                      [_vm._v("Back")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.prodClassCriteria.current_slide_number != 0 &&
            this.prodClassCriteria.classificationFinalized === true
              ? _c("div", {
                  staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12",
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-lg-3 col-md-3 col-xs-12 col-sm-12" },
              [
                _vm.prodClassCriteria.current_slide_number == 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button m-t5",
                        attrs: {
                          id: "footerNext",
                          "data-toggle": "tab",
                          disabled: this.validationMsg !== "",
                        },
                        on: { click: _vm.validateForm },
                      },
                      [_vm._v(" Next ")]
                    )
                  : _vm._e(),
                _vm.prodClassCriteria.current_slide_number > 0 &&
                _vm.prodClassCriteria.current_slide_number < 2
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button m-t5",
                        attrs: {
                          id: "footerNext",
                          "data-toggle": "tab",
                          disabled:
                            this.validationMsg !== "" ||
                            _vm.form_validation_messages[
                              "ivdr_total_components"
                            ]["displayError"] ||
                            _vm.ivdrTotalComponents === 1,
                        },
                        on: { click: _vm.nextValidate },
                      },
                      [_vm._v(" Next ")]
                    )
                  : _vm._e(),
                _vm.prodClassCriteria.current_slide_number == 2 &&
                _vm.permissions.includes("CLASSIFICATION_RESULTS") &&
                !_vm.ivdrKitFlow
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button m-t5",
                        attrs: { id: "footerNext", "data-toggle": "tab" },
                        on: { click: _vm.finalizeClassification },
                      },
                      [_vm._v(" Result ")]
                    )
                  : _vm._e(),
                _vm.prodClassCriteria.current_slide_number == 2 &&
                _vm.permissions.includes("CLASSIFICATION_RESULTS") &&
                _vm.ivdrKitFlow &&
                _vm.prodClassCriteria.country === "EU IVDR" &&
                _vm.ivdrTotalComponents > _vm.ivdrCurrCtr
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button m-t5",
                        attrs: { id: "footerNext", "data-toggle": "tab" },
                        on: { click: _vm.continueKitComponent },
                      },
                      [_vm._v(" Classify Remaining Components ")]
                    )
                  : _vm._e(),
                _vm.prodClassCriteria.current_slide_number == 2 &&
                _vm.permissions.includes("CLASSIFICATION_RESULTS") &&
                _vm.ivdrKitFlow &&
                _vm.ivdrTotalComponents == _vm.ivdrCurrCtr
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button m-t5",
                        attrs: { id: "footerNext", "data-toggle": "tab" },
                        on: { click: _vm.finalizeClassificationKit },
                      },
                      [_vm._v(" Finalize Results ")]
                    )
                  : _vm._e(),
                this.prodClassCriteria.classificationFinalized == true &&
                _vm.prodClassCriteria.current_slide_number == 3
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button m-t5",
                        on: { click: _vm.startOver },
                      },
                      [_vm._v(" Start Over ")]
                    )
                  : _vm._e(),
              ]
            ),
            this.prodClassCriteria.classificationFinalized == false &&
            (_vm.prodClassCriteria.current_slide_number === 2 ||
              _vm.prodClassCriteria.current_slide_number === 1)
              ? _c(
                  "div",
                  { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button m-t5",
                        attrs: { id: "footerNext", "data-toggle": "tab" },
                        on: { click: _vm.startOver },
                      },
                      [_vm._v(" Start Over ")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.prodClassCriteria.current_slide_number <= 3
              ? _c(
                  "div",
                  { staticClass: "col-lg-3 col-md-4 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-blue-button m-t5",
                        attrs: { id: "footerNext", "data-toggle": "tab" },
                        on: { click: _vm.navProdClassDashboard },
                      },
                      [_vm._v(" Back To Dashboard ")]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm.atleastOneReportReady === true
          ? _c(
              "div",
              { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm.ivdrKitFlow
                      ? _c("classification-debug-kit", {
                          attrs: {
                            dtlDebug: _vm.lowDebug,
                            mainDebug: _vm.debug,
                            prodClassCriteria: _vm.prodClassCriteria,
                            ivdrCurrCtr: _vm.ivdrCurrCtr,
                            criteriaMap: _vm.searchCriteriaMap,
                          },
                        })
                      : _c("classification-debug", {
                          attrs: {
                            dtlDebug: _vm.lowDebug,
                            mainDebug: _vm.debug,
                            prodClassCriteria: _vm.prodClassCriteria,
                            ivdrCurrCtr: _vm.ivdrCurrCtr,
                            criteriaMap: _vm.searchCriteriaMap,
                          },
                        }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c("uk-disclaimer-modal"),
      _c("complimentary-access-popup"),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row padding_rl20" }, [
      _c(
        "div",
        {
          staticClass: "col-md-11 class_question",
          staticStyle: { "padding-bottom": "10px" },
        },
        [_vm._v(" Get started by telling us a little bit about your device. ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-sm-4 col-md-4 col-lg-4 margin_bottom_15" },
      [
        _c("span", { staticClass: "sub_heading" }, [
          _vm._v(" What type of device are you registering? "),
          _c("span", { staticClass: "required_astric" }, [_vm._v("*")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-4 col-md-4 col-lg-4" }, [
      _c("span", { staticClass: "sub_heading" }, [
        _vm._v(" Country "),
        _c("span", { staticClass: "required_astric" }, [_vm._v("*")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-4 col-md-4 col-lg-4" }, [
      _c("span", { staticClass: "sub_heading" }, [
        _vm._v(" Device Name "),
        _c("span", { staticClass: "required_astric" }, [_vm._v("*")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }